import QuoteDetailItem, { QuoteDetailItemProps } from './QuoteDetailItem';

export type { QuoteDetailItemProps };
export default QuoteDetailItem;
